const { actionCreators } = require("react/api/actions/monitor");

App.Views.Map = {

    time: 300,
    larguraMapPanel: 0,
    larguraNotification: 0,
    adjustsLayoutContainerSelector: "#Maps #adjustsLayoutContainer",
    mapContainerSelector: "#Maps #mapContainer",
    HIDE_CLASS: ' hide',

    hideRoutePanel: function () {

        /*
         * Chama a função para calcular o tamanho do painel a ser contraído
         */

        var adjustsLayoutContainer = document.querySelector(this.adjustsLayoutContainerSelector);
        adjustsLayoutContainer.style.left = '0px';
        var mapContainerSelector = document.querySelector(this.mapContainerSelector);
        mapContainerSelector.style.left = '0px';

    },

    showRoutePanel: function () {

        var adjustsLayoutContainer = document.querySelector(this.adjustsLayoutContainerSelector);
        adjustsLayoutContainer.style.left = '275px';

        var mapContainer = document.querySelector(this.mapContainerSelector);
        mapContainer.style.left = '275px';

        var timeOut = setTimeout(function () {

            App.MakeLayouts.screenConfigurationFunctions();
            $("#alertEventUrgentInMap").css("left", 5);

            clearTimeout(timeOut);

        }, this.time);


    },

    /*
     * Remove o html das colunas de ação
     */

    clearMenu: function () {
        $(".routeMenu").remove();
    },

    tableChecker: function () {

        var route = $(".full").css("z-index");
        var stop = $(".stops").css("z-index");
        var order = $(".orders").css("z-index");
        var lineItme = $(".lineItems").css("z-index");

        if (parseInt(route, 10) === 100) {
            return "Route";
        }

        if (parseInt(stop, 10) === 100) {
            return "Stop";
        }

        if (parseInt(order, 10) === 100) {
            return "Order";
        }

        if (parseInt(lineItme, 10) === 100) {
            return "LineItme";
        }

    },

    removeMarkers: function () {
        const layers = Monet.Session.mainMap.map._layers;
        App.Routers.RouteMonitor.markers.unspiderfy();

        for (let key in layers) {
            if (layers[key].kind === 'EQUIPMENT' || typeof layers[key]._childCount !== 'undefined') {
                Monet.Session.mainMap.map.removeLayer(layers[key]);
            }
        }
        this.addMarkers();
    },

    addMarkers: function () {
        App.Objects.RouteMonitor.getEquipmentPositionsByOrganizations();
    },

    addAllMarkers: function () {
      Monet.Session.Maps.mainMap.truckStatusFilter.noCommunication = true;
      Monet.Session.Maps.mainMap.truckStatusFilter.moving = true;
      Monet.Session.Maps.mainMap.truckStatusFilter.stopped = true;
      Monet.Session.Maps.mainMap.truckStatusFilter.turnedOff = true;

      window.globalStore.dispatch(actionCreators.resetEquipmentFilters());

      App.Views.Map.addMarkers();
    }

};
